import { render, staticRenderFns } from "./ExerciseTypesPicker.vue?vue&type=template&id=5613c118&scoped=true"
import script from "./ExerciseTypesPicker.vue?vue&type=script&lang=js"
export * from "./ExerciseTypesPicker.vue?vue&type=script&lang=js"
import style0 from "./ExerciseTypesPicker.vue?vue&type=style&index=0&id=5613c118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5613c118",
  null
  
)

export default component.exports